export const Logo = ({ dark = false, className = "" }) => {
  return (
    <a
      href="#top"
      data-testid="brand-logo"
      className={`group inline-flex items-center gap-3 ${className}`}
    >
      <img
        src="/golden-decor-logo.png"
        alt="Golden Decor logo"
        className="h-12 w-12 rounded-full object-cover ring-1 ring-[#C5A059]/40 transition-transform duration-500 group-hover:scale-105"
      />
      <span className="flex flex-col leading-none">
        <span className="font-heading text-2xl font-semibold tracking-tight">
          <span style={{ color: "#EFB90C" }}>Golden</span>{" "}
          <span style={{ color: dark ? "#FCFBF8" : "#111111" }}>Decor</span>
        </span>
        <span
          className="font-body text-[9px] uppercase tracking-[0.34em]"
          style={{ color: dark ? "#8f8b82" : "#111111" }}
        >
          Wedding &amp; Events
        </span>
      </span>
    </a>
  );
};
